import { useEffect, useState } from "react";
import { ArrowUpRight, Menu, MessageCircle, ShoppingBag, X } from "lucide-react";
import { PHONE_NUMBER, whatsappLink } from "@/App";

const links = [
  ["01. Selezione", "materiali", "nav-link-materials"],
  ["02. Lavorazioni", "lavorazioni", "nav-link-finishes"],
  ["03. Archivio", "archivio", "nav-link-projects"],
  ["04. Preventivo", "preventivo", "nav-link-calculator"],
];

export default function Header({ cartCount, onOpenCart, onQuote }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const update = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", update, { passive: true });
    update();
    return () => window.removeEventListener("scroll", update);
  }, []);

  const closeMenu = () => setMenuOpen(false);
  const cartLabel = `${cartCount} ${cartCount === 1 ? "articolo" : "articoli"} nel carrello`;

  return (
    <header className={`site-header ${scrolled ? "is-scrolled" : ""}`} style={scrolled ? { backgroundColor: "var(--bg)", backgroundImage: "none" } : undefined} data-testid="main-navigation-header">
      <div className="header-inner">
        <a className="brand-lockup" href="#top" data-testid="main-nav-logo" onClick={closeMenu}>
          <img className="brand-logo" src="/assets/stoneinlove-logo-header.webp" alt="StoneInLove SIL — Travertini Romani / Tivoli" width="360" height="313" decoding="async" data-testid="brand-logo" />
        </a>
        <button className="menu-toggle" type="button" aria-label="Apri menu" aria-expanded={menuOpen} onClick={() => setMenuOpen((open) => !open)} data-testid="header-menu-toggle">
          {menuOpen ? <X size={19} strokeWidth={1.5} /> : <Menu size={19} strokeWidth={1.5} />}
        </button>
        <nav className={`header-nav ${menuOpen ? "is-open" : ""}`} aria-label="Navigazione principale">
          {links.map(([label, target, testId]) => (
            <a key={target} href={`#${target}`} data-testid={testId} onClick={closeMenu}>{label}</a>
          ))}
        </nav>
        <div className="header-actions">
          <button className="sample-counter" type="button" onClick={onOpenCart} aria-label={`Apri il carrello (${cartLabel})`} data-testid="sample-cart-count"><ShoppingBag size={15} /> <span className="cart-count-number">{cartCount}</span><span className="cart-counter-label">nel carrello</span></button>
          <a className="header-whatsapp" href={whatsappLink()} target="_blank" rel="noreferrer" data-testid="btn-whatsapp-header">
            <MessageCircle size={15} /> <span>WhatsApp</span>
          </a>
          <button className="header-quote" type="button" onClick={onQuote} data-testid="header-quote-button">Richiedi <ArrowUpRight size={15} /></button>
        </div>
      </div>
      <a className="header-phone" href={`tel:${PHONE_NUMBER.replace(/\s/g, "")}`} data-testid="quick-call-phone-button">{PHONE_NUMBER}</a>
    </header>
  );
}
